import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  totalAmount: 0,
  discount: 0,
  couponCode: null,
  couponDetails: null
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      // Check if item already exists
      const existingItem = state.items.find(item => 
        item.id === action.payload.id && item.type === action.payload.type
      );
      if (!existingItem) {
        // إضافة الكمية إذا لم تكن موجودة
        const newItem = {
          ...action.payload,
          quantity: action.payload.quantity || 1
        };
        state.items.push(newItem);
        state.totalAmount += newItem.price * newItem.quantity;
      } else {
        // زيادة الكمية إذا كان المنتج موجود بالفعل
        existingItem.quantity += action.payload.quantity || 1;
        state.totalAmount += existingItem.price * (action.payload.quantity || 1);
      }
    },
    removeFromCart: (state, action) => {
      const itemIndex = state.items.findIndex(item => 
        item.id === action.payload.id && item.type === action.payload.type
      );
      if (itemIndex !== -1) {
        state.totalAmount -= state.items[itemIndex].price * state.items[itemIndex].quantity;
        state.items.splice(itemIndex, 1);
        
        // إذا أصبحت السلة فارغة، نمسح الكوبون
        if (state.items.length === 0) {
          state.couponCode = null;
          state.couponDetails = null;
          state.discount = 0;
        }
      }
    },
    clearCart: (state) => {
      state.items = [];
      state.totalAmount = 0;
      state.discount = 0;
      state.couponCode = null;
      state.couponDetails = null;
    },
    
    // زيادة كمية منتج
    increaseQuantity: (state, action) => {
      const item = state.items.find(item => 
        item.id === action.payload.id && item.type === action.payload.type
      );
      if (item) {
        item.quantity += 1;
        state.totalAmount += item.price;
      }
    },
    
    // تقليل كمية منتج
    decreaseQuantity: (state, action) => {
      const item = state.items.find(item => 
        item.id === action.payload.id && item.type === action.payload.type
      );
      if (item && item.quantity > 1) {
        item.quantity -= 1;
        state.totalAmount -= item.price;
      }
    },
    
    // إضافة كوبون خصم
    applyCoupon: (state, action) => {
      const { code, discount, details } = action.payload;
      state.couponCode = code;
      state.discount = discount;
      state.couponDetails = details;
      
      // تحديث السعر الإجمالي بعد الخصم
      // لا نحتاج لتغيير totalAmount لأنه يمثل المجموع قبل الخصم
      // ونقوم بحساب الإجمالي بعد الخصم في العرض باستخدام totalAmount - discount
    },
    
    // إزالة كوبون خصم
    removeCoupon: (state) => {
      state.couponCode = null;
      state.discount = 0;
      state.couponDetails = null;
    },
    updatePrices: (state, action) => {
      const priceMap = action.payload; // {id_type: price}
      state.items.forEach(item => {
        const key = `${item.id}_${item.type}`;
        if (priceMap[key] !== undefined) {
          item.price = priceMap[key];
        }
      });
      state.totalAmount = state.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    },
  },
});

export const { 
  addToCart, 
  removeFromCart, 
  clearCart, 
  increaseQuantity, 
  decreaseQuantity, 
  applyCoupon, 
  removeCoupon,
  updatePrices
} = cartSlice.actions;

export default cartSlice.reducer;
